import React, { memo } from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

const Loading = ({ message = 'Chargement en cours...' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <CircularProgress color='primary' size={60} />
        <Typography variant='body1' color='text.secondary' mt={2}>
          {message}
        </Typography>
      </Box>
    </Box>
  )
}

export default memo(Loading)
